import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, Message } from 'primeng/api';
import { AdiantamentoFolha } from 'src/app/admihair/api/dto/adiantamento-folha';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { FolhaPessoaFisica } from 'src/app/admihair/api/dto/folha-pessoa-fisica';
import { AdiantamentoFolhaService } from 'src/app/admihair/service/adiantamento-folha.service';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { AuthUtil } from 'src/app/admihair/util/auth-util';

@Component({
  selector: 'app-adiantamento-editar',
  templateUrl: './adiantamento-editar.component.html',
  styleUrls: ['./adiantamento-editar.component.scss']
})
export class AdiantamentoEditarComponent implements OnInit {

  permissaoEditar: boolean = false;
  messages: Message[] = [];
  messagemVisivel: boolean = false;
  loading: boolean = false;
  progressoRequisicao: boolean = false;
  empresaSelecionada?: Empresa;
  id?: number
  adiantamentoFolha?: AdiantamentoFolha;
  parcelasAdiantamentoFolha: FolhaPessoaFisica[] = [];
  exibirRedirecionar?: Boolean = false;

  constructor(private adiantamentoFolhaService: AdiantamentoFolhaService,
    private confirmationService: ConfirmationService,
    private utilStorageService: UtilStorageService,
    private _activatedRoute: ActivatedRoute,
    private erroService: ErroService,
    private _router: Router
    ) { }


  ngOnInit(): void {
    this.loading = true;
    this.permissaoEditar = this.verificarPermissao('PERM_EDITAR_ADIANTAMENTO_FOLHA');
    this.empresaSelecionada = this.utilStorageService.getEmpresa();
    this.carregarId();
    if (this.permissaoEditar) {
      this.carregarAdiantamento();
    }
  }

  carregarId(){
    const idParam = this._activatedRoute.snapshot.paramMap.get('id');
    if(idParam){
      this.id = parseInt(idParam);
    }
  }

  carregarAdiantamento(){
    this.adiantamentoFolhaService.buscarPorId(this.id).subscribe({
      next: (data: AdiantamentoFolha) => {
        this.loading = false;
        this.adiantamentoFolha = data;

        this.adiantamentoFolha.data = new Date(data.data + 'T05:00:00Z');
        this.adiantamentoFolha.dataCobranca = new Date(data.data + 'T05:00:00Z');

        if(data.listaFolha){
          this.parcelasAdiantamentoFolha = data.listaFolha;
          this.parcelasAdiantamentoFolha.forEach(item => item.dataCompetencia = new Date(item.dataCompetencia + 'T05:00:00Z'))
        }

        if(this.parcelasAdiantamentoFolha.length === 0){
          this.excluirAdiantamento();
        }
      },
      error: (err: any) => {
        this.loading = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
      }
    });
  }

  atualizar(){
    this.progressoRequisicao = true;
    if(this.adiantamentoFolha){
      this.adiantamentoFolha.operador = this.utilStorageService.getUser().usuario.id;
    }
    
    this.adiantamentoFolhaService.atualizar(this.adiantamentoFolha, this.id).subscribe({
      next: (data: AdiantamentoFolha) => {
        this.carregarAdiantamento();
        this.progressoRequisicao = false;
        this.messages = this.erroService.handleSuccess();
        this.messagemVisivel = true;
        this.rolarTela();
      },
      error: (err: any) => {
        this.carregarAdiantamento();
        this.progressoRequisicao = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
        this.rolarTela();
      }
    })
  }

  excluirAdiantamento(){
        this.adiantamentoFolhaService.excluir(this.id).subscribe({
          next: () => {
            this.exibirRedirecionar = true;
          },
          error: (err: any) => {
            this.exibirRedirecionar = false;
            this.messages = this.erroService.handleErro(err);
            this.messagemVisivel = true;
            this.rolarTela();
          }
        });
  }


  excluirItemFolha(id: number){
    this.confirmationService.confirm({
      message: 'Tem certeza que seja excluir?',
      header: 'Confirmação',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.adiantamentoFolhaService.excluirParcela(id).subscribe({
          next: () => {
            this.carregarAdiantamento();
            this.messages = this.erroService.handleSuccess();
            this.messagemVisivel = true;
            this.rolarTela();
          },
          error: (err: any) => {
            this.messages = this.erroService.handleErro(err);
            this.messagemVisivel = true;
            this.rolarTela();
          }
        })
        
      }
    });
  }

  redirecionarListagem(){
    this._router.navigate(["/apps/adiantamento/"], { relativeTo: this._activatedRoute })
  }


  verificarPermissao(nome: string): boolean{
    return AuthUtil.verificarPermissao(nome);
  }

  rolarTela(){
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

}
